module.exports = __webpack_public_path__ + "img/signup-btn-img.0cfd775b.svg";